import INumberComponent from '@components/FormFlow/Interfaces/FormflowComponents/INumberComponent';
import { ComponentType } from '@interfaces/component-type';
import Switch from '@material-ui/core/Switch';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Col, InputNumber, Row } from 'antd';
import React from 'react';

import ProcessContext from '../ProcessContext';

interface INumberTaskComponentStateType {
  min?: number;
  max?: number;
  speech: boolean;

};

export class NumberComponent implements INumberComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;
  repeat: boolean;
  minRepeat: number;
  maxRepeat: number;
  min?: number;
  max?: number;
  step: number;
  speech: boolean;

  constructor(id: string = '') {
    this.id = id;
    this.required = false;
    this.type = ComponentType.NUMBER;
    this.title = '';
    this.repeat = false;
    this.minRepeat = 0;
    this.maxRepeat = 0;
    this.min = Number.MIN_SAFE_INTEGER;
    this.max = Number.MAX_SAFE_INTEGER;
    this.step = 0;
    this.speech = false;
    return this;
  }
}

export default class NumberComponentProcess extends React.Component<any, INumberTaskComponentStateType> {

  constructor(props: INumberComponent) {
    super(props);
    this.state = {
      min: this.props.min && this.props.min != Number.MIN_SAFE_INTEGER ? this.props.min : undefined,
      max: this.props.max && this.props.max != Number.MAX_SAFE_INTEGER ? this.props.max : undefined,
      speech: this.props.speech || false
    };
  }

  //#region HANDLERS

  handleMinChange = async (evt: any) => {
    const {max} = this.state; 
      if(max !== undefined && evt > max || max === undefined){
        this.setState({ max: evt });
      }
      this.setState({ min: evt  }); 
  }
  handleMaxChange = async (evt: any) => {
    const {min, max} = this.state;
      if(min !== undefined && evt < min || min === undefined){
        this.setState({ min: evt })
      }
        this.setState({ max: evt });
  }
  handleSpeechChange = async (evt: any) => {
    this.setState({ speech: evt.target.checked });
  }

  onSave(updateFormflowWithComponent: (component: any) => void) {
    const newComponent = {
      min: this.state.min ? this.state.min : Number.MIN_SAFE_INTEGER,
      max: this.state.max ? this.state.max : Number.MAX_SAFE_INTEGER,
      speech: this.state.speech,
      step: 0
    }
    updateFormflowWithComponent(newComponent);
  }

  //#endregion

  render() {
    
    return (
      <>
        <CardConfig >
          <Row>
            <Col sm={20} md={20} xl={20} >
              {I18n.l('label.voiceCommandNumberComponent')}
            </Col>
            <Col sm={4} md={4} xl={4} >
              <Switch
                color="primary"
                onChange={this.handleSpeechChange}
                checked={this.state.speech}
              />
            </Col>
          </Row>
        </CardConfig>
        <DividerBorder />
        <CardConfig style={{ marginTop: '25px' }} >
          {I18n.l('label.minNumberComponent')}
          <div>
            <InputNumber
              onChange={this.handleMinChange}
              value={this.state.min}
              style={{ marginTop: '10px', width: '40%' }}
              placeholder={I18n.l('label.insertNumberPlaceholder')}
            />
          </div>
        </CardConfig>
        <DividerBorder />
        <CardConfig style={{ marginTop: '25px' }}>
          {I18n.l('label.maxNumberComponent')}
          <div>
            <InputNumber
              value={this.state.max}
              onChange={this.handleMaxChange}
              style={{ marginTop: '10px', width: '40%' }}
              placeholder={I18n.l('label.insertNumberPlaceholder')}
            />
          </div>
          <ProcessContext.Consumer>
            {({ updateProcessComponent }) => (
              <>
                {this.onSave(updateProcessComponent)}
              </>
            )}
          </ProcessContext.Consumer>
        </CardConfig>
        <DividerBorder />
      </>
    );
  }
}

//#region CSS
const CardConfig = styled.div`
padding-bottom: 25px;
height:auto;
background-color: #F6FCFD;

`;

const DividerBorder = styled.div`
    border-bottom: 1px solid  ${Theme.secondary.lightGrey};
    width: 120%;
    margin-left: -29px;
`;
//#endregion
